import type {
    PriceListUerRowInput,
    WorkOrderChangeObjectItem,
    WorkOrderObjectData,
    WorkOrderStatusEnum,
} from 'gql/graphql';
import { ChapterEnum } from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';
import * as R from 'ramda';

export const ADD_UER_STEPS = [
    {
        stepId: 0,
        label: 'Выбор объекта',
    },
    {
        stepId: 1,
        label: 'Выбор расценок',
    },
];

export const CHAPTER_ITEMS = [
    { id: ChapterEnum.Chapter1_7, label: 'Глава 1-7' },
    { id: ChapterEnum.Chapter8, label: 'Глава 8' },
    { id: ChapterEnum.Chapter9, label: 'Глава 9' },
];

export interface IObjectTabFilters {
    chapter?: (typeof CHAPTER_ITEMS)[number] | null;
    object?: {
        id: number;
        label: string;
    };
}

export interface IFilterVariables {
    workOrderId?: number;
    workOrderChangeId?: number;
    constructionTypeId: number;
    workOrderObjectIds?: number[];
    chapter: ChapterEnum | undefined;
}

export interface IAddWorkOrderUerProps {
    constructionTypeId: number;
    onClose: () => void;
    reloadWorkOrderTable: () => void;
    workOrderId: number;
    contractId: number;
    objectId: number | undefined;
    subObjectId: number | undefined;
    workOrderStatus: WorkOrderStatusEnum | undefined;
    catalogVersion: string;
    catalogName: string;
}

export interface IAddPricesToWorkOrderProps {
    workOrderObjectIds: number[];
    chapter: ChapterEnum | undefined;
    workOrderId: number;
    constructionTypeId: number;
    uerInputs: PriceListUerRowInput[] | undefined;
    onClose: () => void;
    reloadWorkOrderTable: () => void;
}

export interface IAddWorkOrderUerTabContentProps {
    activeStep: (typeof ADD_UER_STEPS)[number] | undefined;
    workOrderObjects: WorkOrderObjectData[] | null | undefined;
    constructionTypeId: number;
    objectTabFilters: IObjectTabFilters;
    onChangeObjectTabFilters: (value: IObjectTabFilters) => void;
    onChangeCheckedObjects: (value: { [key: number]: boolean }) => void;
    onChangeCheckedPrices: (value: { [key: number]: boolean }) => void;
    checkedObjects: { [key: number]: boolean | 'intermediate' };
    checkedPrices: { [key: number]: boolean };
    workOrderId: number;
    workOrderObjectIds: number[];
    getObjItemDisabled?: (item: { id: any; label: string }) => boolean;
    getObjItemLabel?: (item: { id: any; label: string }) => any;
}

export type IObjectTableColumnsProps = Pick<
    IAddWorkOrderUerTabContentProps,
    'checkedObjects' | 'onChangeCheckedObjects'
>;

export type IPriceTabDataProps = Pick<
    IAddWorkOrderUerTabContentProps,
    'workOrderId' | 'constructionTypeId' | 'workOrderObjectIds'
> & {
    chapter: ChapterEnum | undefined;
};

export type ICheckedObjectsCellRendererProps = IObjectTableColumnsProps & ICellRendererParams;

const getParentProp = (item: WorkOrderObjectData | WorkOrderChangeObjectItem) => item.parentId;

export const groupWorkOrderObjectsByParentId = R.groupBy(getParentProp);
const makeObjectsTree = (
    tree: Record<string, (WorkOrderObjectData | WorkOrderChangeObjectItem)[]>,
    parentId: number,
    level = 1,
) =>
    (tree[parentId] ?? []).reduce((acc: any, item: WorkOrderObjectData | WorkOrderChangeObjectItem) => {
        const children = makeObjectsTree(tree, item.id, level + 1);

        acc.push({ ...item, level }, ...children);

        return acc;
    }, []);

export const getObjectsTree = (
    items: (WorkOrderObjectData | WorkOrderChangeObjectItem)[],
    rootId: number,
): (WorkOrderObjectData & { level: number })[] => {
    const grouped = groupWorkOrderObjectsByParentId(items);

    return makeObjectsTree(grouped, rootId);
};
